import { useState, useEffect } from 'react';

export function useImageNotAvailable(pictureUrl) {
    const [img, setImg] = useState('');
    useEffect(() => {
        setImg(pictureUrl);
    }, [pictureUrl]);

    return img;
}
